module.exports = __webpack_public_path__ + "static/img/3.bb01749.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/3.png
// module id = wXvF
// module chunks = 0